import ILoader = KalturaPlayerTypes.ILoader;
import {KalturaCaption} from './kaltura-caption';

const {RequestBuilder} = KalturaPlayer.providers;
interface CaptionResponse {
  captionAssets: Array<KalturaCaption>;
}
export class CaptionListLoader implements ILoader {
  private _entryId;
  _requests: any[] = [];
  _response: CaptionResponse = {captionAssets: []};

  static get id(): string {
    return 'caption-list';
  }

  /**
   * @constructor
   * @param {Object} params loader params
   */
  constructor(params: {entryId: string}) {
    this._entryId = params.entryId;
    const headers: Map<string, string> = new Map();
    const request = new RequestBuilder(headers);

    request.service = 'caption_captionasset';
    request.action = 'list';
    request.params = {
      filter: {
        objectType: 'KalturaCaptionAssetFilter',
        entryIdEqual: this._entryId,
      }
    };
    this.requests = [request];
  }

  set requests(requests: any[]) {
    this._requests = requests;
  }

  get requests(): any[] {
    return this._requests;
  }

  set response(response: any) {
    const captionList = response[0]?.data?.objects;
    this._response.captionAssets = captionList;
  }

  get response(): any {
    return this._response;
  }

  /**
   * Loader validation function
   * @function
   * @returns {boolean} Is valid
   */
  isValid(): boolean {
    return !!this._entryId;
  }
}
